import { FillPause, LockBadge, TrackedPlay } from "../../Assets/svg";
import { useDispatch, useSelector } from "react-redux";
import "./style.css";
import { useEffect, useRef, useState } from "react";
import { activeUser } from "../../Store/Slices/APIs";
import { addSingleTrack, appendTracksToPlaylist, playAllTracks, removeSingleTrack, setConfig, togglePlayPause } from "../../Store/Slices/PlayerSlice";
import { setIsMixSaved, setMixSavedId } from "../../Store/Slices/SaveMixSlice";
import { getPlaylistType, GetSelectedTrackIdByPlaylistType, showPlaylistOption } from "../../Util/helpers";
import AddToPlaylistButton from "../BottomPlayerBar/Playlist/AddToPlaylistButton";
import { Link } from "react-router-dom";

const RoundAudio = (props) => {

  const playlist_config = {
    id: props?.item?.id,
    name: props?.item?.title,
    data: [props?.item],
    isSavedPlaylist: false,
    playlist_type: getPlaylistType(props?.item),
    parent_category_id: props?.parentCategoryId
  };

  const dispatch = useDispatch();

  const tracks = useSelector((state) => state.player.playingTracks);
  const config = useSelector((state) => state.player.config);
  const isPlaying = useSelector((state) => state.player.isPlaying);

  const isPlaylist = config.type === "playlist";

  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    if (config?.type === "mix") {
      setIsSelected(config['id'] === props?.item.id);
    } else if (config?.type === "playlist") {
      if (config['playlist_type'] === "article_stories_relaxation") {
        setIsSelected(config['shouldPlay'] === props?.item.id);
      } else {
        if (props?.item.soundcategory === 163 || props?.item.soundcategory === 164) {
          setIsSelected(config['playingId'] === props?.item.id);
        } else {
          setIsSelected(tracks.some(t => t.id === props?.item.id));
        }
      }
    } else {
      setIsSelected(tracks.some(t => t.id === props?.item.id));
    }
  }, [tracks, config.restartId, config.playingId, config.shouldPlay, props?.item.id]);

  const handleCardClick = () => {

    const item = props?.item;
    const filter = tracks.some(t => t.id === item?.id);

    if (config?.is_system_playlist && filter) {
      // Handle system playlist logic
      dispatch(setConfig({
        playingId: item?.id,
      }));
      return;
    }

    // Update mix state
    dispatch(setMixSavedId(null));

    // Active User
    dispatch(activeUser());

    // Add or remove tracks
    if (isSelected) {
      dispatch(togglePlayPause());
      return;
    } else {
      const data = isPlaylist ? [...tracks, ...[item]] : [];
      const type = isPlaylist ? 'playlist' : 'default';
      const obj = {
        id: isPlaylist ? config.id : item?.id,
        type: type,
        data: data,
        playingId: isPlaylist ? config.playlist_ended ? item?.id : config.playingId : null,
        restartId: config.playlist_ended ? item?.id : null,
        isRepeat: isPlaylist ? config.isRepeat : false,
        isShuffle: isPlaylist ? config.isShuffle : false,
        isPlaylist: false,
        isPlaylistMix: config?.isPlaylistMix || false,
        shouldPlay: GetSelectedTrackIdByPlaylistType(item, config),
        playlist_ended: false
      }
      dispatch(isPlaylist ? appendTracksToPlaylist([item]) : addSingleTrack({ item }));
      dispatch(setConfig(obj));
      dispatch(playAllTracks());
    }
  };


  return (
    // <div className={`${isSelected && 'gradient'} roundAudioWrapper`}>
    //   <div
    //     className={`roundAudio ${props?.indexes}`}
    //     onClick={handleCardClick}
    //   >
    //     <div className="imageWrapper">
    //       <img
    //         src={`${props?.item.image && !props?.showThumnail ? props?.item.image : props?.item.tumbnail ? props?.item.tumbnail : props?.item.thumbnail}`}
    //         alt="Sound Thumbnail"
    //       />
    //     </div>
    //     <p>{props?.item.title}</p>
    //     {props?.item.premium && (
    //       <span className="premiumBadge">
    //         <LockBadge />
    //       </span>
    //     )}
    //   </div>
    // </div>
    <div className={`audioStrip ${isSelected && 'gradient'}`}>
      <Link to="#_" className="audioStripDetails">
        <img src={props?.item?.image} alt="" />
        <p>{props?.item?.title || props?.item?.name}</p>
      </Link>
      <div className="audioStripExtra">
        <button type="button" className="audioStripButton audioStripPlay" onClick={handleCardClick}>
          {isSelected && isPlaying ? (<img src={FillPause} />) : (<img src={TrackedPlay} />)}
        </button>
        {showPlaylistOption(props?.item) && (
          <AddToPlaylistButton config={playlist_config} />
        )}
      </div>
    </div>
  );


};

export default RoundAudio;
